module.exports = __webpack_public_path__ + "img/edmunds.6f32571e.png";